import { render, staticRenderFns } from "./QuotazioneRCAPage.vue?vue&type=template&id=0452d40c"
import script from "./QuotazioneRCAPage.vue?vue&type=script&lang=js"
export * from "./QuotazioneRCAPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports